import React from "react";
import NavigationComponent from "../../../commonComponents/util/NavigationComponent";
import ReconciliationAdjustmentModal from "./ReconciliationAdjustmentModal";
import { formatCurrency } from "../../../../lib/utils";

export default class ReconciliationAdjustmentsList extends NavigationComponent {
  state = {
    editAdjustmentIndex: null,
    showModals: {
      editAdjustmentModal: false
    }
  };

  onEditAdjustment = adjustment => {
    const { adjustments, updateAdjustments } = this.props;

    const editedAdjustments = [...adjustments];
    editedAdjustments[this.state.editAdjustmentIndex] = adjustment;

    updateAdjustments(editedAdjustments);

    this.setState({ editAdjustmentIndex: null });
  };

  onDeleteAdjustment = adjustmentIndex => {
    const { adjustments, updateAdjustments } = this.props;

    updateAdjustments(
      adjustments.filter((adj, index) => index !== adjustmentIndex)
    );
  };

  render() {
    const { adjustments, isIsraeli, type } = this.props;
    const { editAdjustmentIndex, showModals } = this.state;

    return adjustments.length > 0 ? (
      <div className="mb-16">
        {adjustments
          .map((adjustment, index) => ({ adjustment, adjustmentIndex: index }))
          .filter(({ adjustment }) => adjustment.transactionType === type)
          .map(({ adjustment, adjustmentIndex }) => (
            <div
              className="flex flex-justify mb-8 mr-8 medium-text"
              key={adjustmentIndex}
            >
              <p>
                {adjustment.description || ""} (Reconciliation Adjustment):{" "}
                {formatCurrency(adjustment.amount)}
              </p>
              <div className="flex flex-justify">
                <i
                  className="icon-pencil primary-hover input mr-8"
                  onClick={() => {
                    this.setState(
                      {
                        editAdjustmentIndex: adjustmentIndex
                      },
                      () => this.toggleModal("editAdjustmentModal")
                    );
                  }}
                />
                <i
                  className="icon-trash trash-hover input"
                  onClick={() => this.onDeleteAdjustment(adjustmentIndex)}
                />
              </div>
            </div>
          ))}

        <ReconciliationAdjustmentModal
          adjustment={adjustments[editAdjustmentIndex]}
          close={() => this.toggleModal("editAdjustmentModal")}
          isIsraeli={isIsraeli}
          show={showModals.editAdjustmentModal}
          submit={this.onEditAdjustment}
        />
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/NewBankReconciliation/ReconciliationAdjustmentsList.jsx